import commApi from "@/api/apis/common.js";
import md5 from 'js-md5';

// 生成32位字符串
export function getRandomStr32() {
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  var str_nums = "";
  for (var i = 0; i < 32; i++) {
    var id = parseInt(Math.random() * (arr.length - 1));
    str_nums += arr[id];
  }

  if(localStorage.getItem('deviceId')){
    return localStorage.getItem('deviceId')
  }else{
    localStorage.setItem('deviceId',str_nums)
    return str_nums;
  }
}

export function generateRandomStr8(length) {
  // var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  // var uppercase = false, lowercase = false, digit = false;
  // var randomStr = '';
  // while (!(uppercase && lowercase && digit) || randomStr.length < 8) {
  //     var randomNum = Math.floor(Math.random() * chars.length);
  //     randomStr += chars.substring(randomNum, randomNum + 1);
  //     uppercase = /[A-Z]/.test(randomStr);
  //     lowercase = /[a-z]/.test(randomStr);
  //     digit = /\d/.test(randomStr);
  // }
  // return randomStr;

  var result= '';
  var characters= 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// 微信授权登录
export function wxUserInfoAuthorize(callbackURL, wxAppId, state) {
  var redirect = encodeURIComponent(callbackURL || window.location.href);
  //var redirect = encodeURIComponent('https://jms.ctdsb.net/jmythshare/#/login');
  var state = state || 1;
  //console.log('callbackURL:',callbackURL);
  //console.log('微信授权登录:',"https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wxAppId + "&redirect_uri=" + redirect + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect");
  window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wxAppId + "&redirect_uri=" + redirect + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect");
}

// 微信、qq转发统计传参加密
export function wxQqParamsMd5(query){
  delete query.sec;
  delete query.share_plat;
  delete query.uik;

  let uik=generateRandomStr8(8);
  let ua = window.navigator.userAgent.toLowerCase();
  let isWechat = ua.match(/MicroMessenger/i) == 'micromessenger';//是否在微信浏览器
  let isQQ = (ua.indexOf(' qq')>-1) //是否在qq内置浏览器
  
  let share_plat;
  if(isWechat){
    share_plat='wechat';
  }
  if(isQQ){
    share_plat='qq';
  }
  if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua) && !isQQ && !isWechat){
    share_plat='browser';
  }
  
  
  if(share_plat){
    let sec='';
    if(query.contentType == 4){
      sec = md5(uik+query.id+query.contentType+share_plat);
    }else{
      sec = md5(uik+query.contentId+query.contentType+share_plat);
    }
   
    console.log('md5:',md5('rL9zpxwI28582735wechat').substring(0, 8));
    console.log('原串：',uik);
    console.log('加密：',sec);
    sec=sec.substring(0, 8);
    console.log('sec:',sec);
    let params={
      ...query,
      uik,
      share_plat,
      sec
    }
    let pathParams=location.search.replace(/\?/,'');
    if(pathParams!=''){
      let params2=getQueryParams(pathParams);
      params={...params2,...params};
    }
    return params;
  }
  else {
    return false
  }
  
  
}

// 加载地图
/*
* @param {Function} callback 回调函数名称，回调函数将会挂载到window上，例如：window.initBaiduMapScript，在方法中就能拿到BMap对象
*/
export function loadBMap(callback) {
  var script = document.createElement('script');
  script.src = 'https://api.map.baidu.com/api?v=2.0&ak=yoQWRQfnnCyGGrxiNmWHvtKXxgziumIM&callback=' + callback;
  document.body.appendChild(script);
}

// 序列化的参数转换成对象
export function getQueryParams(queryString) {
  const params = new URLSearchParams(queryString);
  const obj = {};
  for (const [key, value] of params) {
    obj[key] = value;
  }
  return obj;
}

// 参数序列化
export function toQueryParams(url, params) {
  const query = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return `${url}?${query}`;
}

// 友盟统计
export function loadStat() {
  var script = document.createElement('script');
  script.src = 'https://v1.cnzz.com/z_stat.php?id=1280689875';
  document.body.appendChild(script);

  // var script1 = document.createElement('script');
  // script1.src = 'https://c.cnzz.com/core.php?web_id=1280689875&t=z';
  // document.body.appendChild(script1);
  // 文字形式
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式1
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式2
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式3
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic2' type='text/javascript'%3E%3C/script%3E"));
}

// 深度复制
export function deepClone(obj) {
  let result = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = obj[key] !== null ? deepClone(obj[key]) : obj[key]
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

// 验证是否是手机号
export function testMobilePhone(phoneNum) {
  // var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(phoneNum);
}

/* 获取URL中的某个参数 */
export function getUrlParamByKey(key) {
  var str = window.location.href;
  if (str.indexOf('?') > -1) {
    str = str.split('?')[1];
    var list = str.split("&");
    for (var i = 0; i < list.length; i++) {
      var k = list[i].split("=")[0];
      var v = list[i].split("=")[1];
      if (k == key) return v;
    }
  }
  return null;
}

// 获取URL中的全部参数
export function getUrlParamObj(url) {
  var arr = [];
  var query = {};
  if (url.indexOf('?') > -1) {
    arr = url.split('?')[1];
    if (arr.length > 0) {
      var list = arr.split("&");
      list.length > 0 && list.forEach(item => {
        let mm = item.split('='),
          key = mm[0],
          value = mm[1];
        query[key] = value
      });
    }
  }
  return query;
}

// 获取一级域名和二级域名
export function getLocationOrigin(){
  let origin = location.origin;
  let path = location.pathname;
  path=path.split('/')[1];
  let name=origin+'/'+path;
  let locationHostUrl = window.location.host
  if(locationHostUrl.indexOf('localhost')!=-1 || locationHostUrl.indexOf('192.168')!=-1){
    name=origin;
  }
  return name;
}

export function reComposeUrl(){
  let href = location.href;
  let isErrHref=href.match(/=.+\?/);
  let isErrHref2=href.match(/\/#\/*[^=\?]+=.+\?/);
  if(isErrHref && isErrHref2){
    let hash=href.match(/\/[^\/]+\?/)[0];
    console.log('hash22222222222222:',hash);
    href=href.replace(/\/[^\/]+\?/,'');
    // let query=href.match(/http.+#/)[0];
    href=href.replace(/#\/*/,'#'+hash);
    console.log('href555555555555:',href);
    window.location.replace(href);
  }
}
export function getUrlParams() {
  const hash = window.location.hash;
  const paramsStr = hash.split('?')[1] || '';
  const params = {};
  paramsStr.split('&').forEach(pair => {
    const [key, value] = pair.split('=');
    if (key) {
      params[key] = decodeURIComponent(value || '');
    }
  });
  return params;
}
/* 获取选项标签 */
export function getSelectLabel(index) {
  var list = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  return list[index];
}

// 点击量
// contentType == 4直播，5图文，6图集，7专题，8占位广告，9视频，11音频，12外链，15，17问答 等类型的加点击量，其他类型的不用加
export function clickPlayCount(params) {
  const hash = getUrlParams()
  console.log(hash)
  var p = {
    categoryType: 0, // 栏目类型:0、普通栏目；1、首页栏目；2、精品栏目 3、推广栏目
    channelId: '', // 栏目id
    channelName: '', // 栏目名称
    contentCreationTime: '', // 创建时间
    contentId: '', // 稿件Id
    contentTitle: '', // 稿件title
    contentType: '', // 内容类型: 1、活动；2、抽奖；3、投票调查；4、直播间；5、图文资讯；6、图集;7、专题；8、占位广告；9、视频 ；10、问卷调查；11、音频； 12、外链；13、自媒体；16、报料 ,17弹窗广告,18:启动页广告
    deviceId: '', // 设备id
    deviceType: 4, // 设备标识1:华为2:小米3:苹果4：未知
    memberId: null, // 当前稿件的编辑者的id
    nickName: '', // 当前稿件的编辑者的用户名称
    sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
  }
  params = Object.assign(p, params);
  params.deviceId = getRandomStr32();
  if(hash && hash.dt == 5 ){
    params.sourceType = 5 
  }
  commApi
    .clickPlayCount(params)
    .then((res) => {
      console.log("统计成功，访问量+1！");
    })
    .catch((err) => {
      console.log("统计成功，访问量+1！");
    });
}

//中宣部访问信息
export function addH5Escalate (){
  var ua = navigator.userAgent;
  var p ={
    ua:ua,
    access:1,
    cookieId:getRandomStr32(),
    carrierType:0
  }
  return new Promise((resolve,reject) =>{
    commApi
      .addH5Escalate(p)
      .then((res) => {
        console.log("中宣部统计成功，访问量+1！");
        resolve(res);
      })
      .catch((err) => {
        console.log("中宣部统计出错！");
        resolve(err);
      });
  });
}


// 增加积分
export function addScore(params) {
  var p = {
    code: "", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
    description: "", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
    contentType: "", // 非必传，稿件的type
    contentId: "", // 非必传，稿件的id
    contentName: "", // 非必传，稿件的标题
    // deviceId:, // 设备id，客户端则传设备id，静态页不传
    memberId: null, // 必传，会员id
  };

  if(window.localStorage.getItem("userInfo")){
    let userInfo = JSON.parse(window.localStorage.getItem("userInfo"))
    if(userInfo&&userInfo.memberId){
      p.memberId=userInfo.memberId
    }
  }else{
    // 没有memberId，不调用积分添加接口
    return
  }
  params = Object.assign(p, params);

  commApi
    .addScore(params)
    .then((res) => {
      if (res.suc == 1) {
        console.log("积分添加成功！");
      } else {
        console.log("积分添加失败！");
      }
    })
    .catch((err) => {
      console.log("积分添加失败！");
    });
}

export function formatUTCDateTime(isoString) {
  const date = new Date(isoString);
  
  // 获取 UTC 时间组件
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}